import { Box } from '@mui/material';

// 외부 서비스가 제공하는 공식 SVG brand color는 제품 UI token으로 치환하지 않는다.
export function GoogleWorkspaceMark({ size = 36 }: { size?: number }) {
  return (
    <Box component="svg" viewBox="0 0 24 24" aria-hidden="true" sx={{ width: size, height: size }}>
      <path fill="#4285F4" d="M21.6 12.23c0-.71-.06-1.4-.18-2.06H12v3.9h5.38a4.6 4.6 0 0 1-2 3.02v2.53h3.24c1.9-1.75 2.98-4.33 2.98-7.39Z" />
      <path fill="#34A853" d="M12 22c2.7 0 4.97-.9 6.62-2.38l-3.24-2.53c-.9.6-2.05.96-3.38.96-2.6 0-4.81-1.76-5.6-4.13H3.05v2.61A10 10 0 0 0 12 22Z" />
      <path fill="#FBBC05" d="M6.4 13.92A6 6 0 0 1 6.08 12c0-.67.12-1.32.32-1.92V7.47H3.05A10 10 0 0 0 2 12c0 1.61.39 3.14 1.05 4.53l3.35-2.61Z" />
      <path fill="#EA4335" d="M12 5.95c1.47 0 2.79.51 3.83 1.5l2.87-2.87A9.63 9.63 0 0 0 12 2a10 10 0 0 0-8.95 5.47l3.35 2.61c.79-2.37 3-4.13 5.6-4.13Z" />
    </Box>
  );
}

export function SlackMark({ size = 36 }: { size?: number }) {
  return (
    <Box component="svg" viewBox="0 0 128 128" aria-hidden="true" sx={{ width: size, height: size }}>
      <path fill="#36C5F0" d="M27 78a13 13 0 1 1-13-13h13v13Zm7 0a13 13 0 0 1 26 0v33a13 13 0 1 1-26 0V78Z" />
      <path fill="#2EB67D" d="M50 27a13 13 0 1 1 13-13v13H50Zm0 7a13 13 0 0 1 0 26H17a13 13 0 1 1 0-26h33Z" />
      <path fill="#ECB22E" d="M101 50a13 13 0 1 1 13 13h-13V50Zm-7 0a13 13 0 0 1-26 0V17a13 13 0 1 1 26 0v33Z" />
      <path fill="#E01E5A" d="M78 101a13 13 0 1 1-13 13v-13h13Zm0-7a13 13 0 0 1 0-26h33a13 13 0 1 1 0 26H78Z" />
    </Box>
  );
}
